export function authHeader() {
  let user = JSON.parse(window.localStorage.getItem("userData"));

  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
}
